import { ThemeUICSSObject, spacing } from '@apia/theme';
/* IMPORT HERE */

const usrFncTree: ThemeUICSSObject = {
  /* PREPEND HERE */
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'nowrap',
  alignItems: 'stretch',
  width: 'min(75vw,600px)',
  maxHeight: '75vh',
  gap: spacing(3),
  overflow: 'hidden',
  '.fieldWrapper': {
    div: {
      width: '100%',
    },
  },
  '.usrFncTreeEnvs': {
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  '.tree': {
    overflowY: 'auto',
    pl: spacing(4),
    pr: spacing(4),
  },
  '.tree__expanderWrapper': {
    display: 'flex',
    alignItems: 'center',
    height: '24px',
  },
  'span.tree__nodeItemLabel': {
    gap: spacing(2),
    overflow: 'hidden',
    minHeight: '24px',
    '.spacer': {
      marginLeft: '7px',
    },
  },
};

export default usrFncTree;
